export const fiscalReport = {
	title: "Informe fiscal",
	activeTab: "informe-fiscal",
	period: "Período",
	errorNotification: "Fecha límite {{date}}",
	sheet: {
		title: "Informe Fiscal",
		filename: "informe_fiscal",
		columns: {
			date: "Fecha",
			eventName: "Evento",
			totalReceipt: "Facturación emitible",
			emitted: "Facturación emitida",
			emittedNfce: "Notas de consumo",
			emittedNfse: "Notas de servicio",
		},
	},
	fiscalProfile: "Perfil fiscal",
	columns: {
		date: "Fecha",
		eventName: "Evento",
		totalReceipt: "Facturación emitible",
		emitted: "Facturación emitida",
		emittedNfce: "Notas de consumo",
		emittedNfse: "Notas de servicio",
		total: "Total",
	},
};
